import { render, staticRenderFns } from "./RegisterProductsTable.vue?vue&type=template&id=0dabe807&scoped=true"
import script from "./RegisterProductsTable.vue?vue&type=script&lang=js"
export * from "./RegisterProductsTable.vue?vue&type=script&lang=js"
import style0 from "./RegisterProductsTable.vue?vue&type=style&index=0&id=0dabe807&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dabe807",
  null
  
)

export default component.exports